import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";


import Footer from "../../components/common/Footer";
import "../../assets/css/packages.css";

import AdminNavbar from "../AdminNavbar";
import PackageCard from "../../components/Packages/PackageCard";

function AdminPackages() {

     const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchServices = async () => {

            try {

                const querySnapshot = await getDocs(collection(db, "packages"));

                const packageList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setServices(packageList);

            } catch (error) {

                console.error("Error fetching packages:", error);

            } finally {

                setLoading(false);

            }

        };

        fetchServices();

    }, []);

    return (

        <section className="customer-packages-page">

            <AdminNavbar />

            {/* ================= HERO ================= */}

            <section className="customer-packages-hero">

                <div className="customer-packages-hero-content">

                    <span className="customer-packages-badge">
                        STORY LINE STUDIOS
                    </span>

                    <h1>
                        Services &amp; Packages
                    </h1>

                    <div className="customer-packages-line"></div>

                    <p>
                        Elegant photography services designed to preserve your
                        most precious memories with timeless artistry, luxury
                        presentation, and unforgettable storytelling.
                    </p>

                </div>

            </section>

            {/* ================= PACKAGES ================= */}

            <section className="customer-packages-container">

                {loading ? (

                    <h2>Loading Packages...</h2>

                ) : services.length > 0 ? (

                    services.map((service) => (

                        <PackageCard
                            key={service.id}
                            id={service.id}
                            title={service.title}
                            image={service.image}
                            price={service.price}
                            features={service.features}
                        />

                    ))

                ) : (

                    <div className="customer-packages-empty">

                        <div className="customer-packages-empty-icon">
                            📦
                        </div>

                        <h2>No Packages Available</h2>

                        <p>
                            We're preparing our latest luxury photography
                            packages. Please check back soon for exciting offers,
                            unforgettable experiences, and beautifully crafted
                            memories.
                        </p>

                    </div>

                )}

            </section>

            {/* ================= WHY CHOOSE US ================= */}

            <section className="customer-packages-why">

                <h2>Why Choose Story Line Studios?</h2>

                <div className="customer-packages-why-grid">

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">📸</div>
                        <h3 className="customer-packages-why-title">
                            Premium Cameras
                        </h3>
                        <p className="customer-packages-why-text">
                            We use professional full-frame cameras and premium
                            lenses to capture every detail with exceptional
                            clarity and elegance.
                        </p>
                    </div>

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">🎬</div>
                        <h3 className="customer-packages-why-title">
                            Cinematic Editing
                        </h3>
                        <p className="customer-packages-why-text">
                            Every image and film is edited with cinematic color
                            grading, artistic storytelling, and luxury
                            finishing.
                        </p>
                    </div>

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">❤️</div>
                        <h3 className="customer-packages-why-title">
                            Experienced Team
                        </h3>
                        <p className="customer-packages-why-text">
                            Our passionate photographers and editors work
                            together to preserve genuine emotions and timeless
                            memories.
                        </p>
                    </div>

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">⚡</div>
                        <h3 className="customer-packages-why-title">
                            Fast Delivery
                        </h3>
                        <p className="customer-packages-why-text">
                            Receive beautifully edited photographs, albums, and
                            cinematic films with reliable and timely delivery.
                        </p>
                    </div>

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">⭐</div>
                        <h3 className="customer-packages-why-title">
                            Affordable Packages
                        </h3>
                        <p className="customer-packages-why-text">
                            Flexible photography packages designed to match
                            every celebration, style, and budget without
                            compromising quality.
                        </p>
                    </div>

                    <div className="customer-packages-why-card">
                        <span></span>
                        <div className="customer-packages-why-icon">🎨</div>
                        <h3 className="customer-packages-why-title">
                            Creative Storytelling
                        </h3>
                        <p className="customer-packages-why-text">
                            We don't just capture photos—we craft visual stories
                            that become treasured memories for generations.
                        </p>
                    </div>

                </div>

            </section>

            <Footer />

        </section>

    );

}
export default AdminPackages;